import React from 'react';
import { Label } from '../../label/label';
import { NackleCaption } from '../../NackleCaption/nackle-caption';
import { Input as AntInput } from 'antd';
import { Eye, EyeClosed } from '@nackle/origami-icons';

/**
 * A password input
 *
 * {@link https://ant.design/components/input#api}
 *
 * @module Password
 * @param {Object} props - the component props
 * @param {string} [props.label] - the label for the password input
 * @param {Object} [props.labelProps] - the props for the password label
 * @param {boolean} [props.caption] - whether or not th epassword input has a caption
 * @param {Object} [props.captionProps] - props for password component caption
 * @param {boolean} [props.captionProps.required] - whether or not the caption is required
 * @param {string} [props.captionProps.text] - text for caption under input
 * @param {string} [props.captionProps.size] - size of caption
 * @param {boolean} [props.disabled] - whether or not the password input is disabled
 * @returns {React.ReactElement} - a password input
**/
const Password = ( { label, labelProps, caption, captionProps, disabled, ...restProps } ) => {
    const passwordIcon = ( visible ) => (
        <span
            role="img"
            aria-label="eye-invisible"
            tabIndex="-1"
        >
            { visible ? <EyeClosed /> : <Eye /> }
        </span>
    );

    return (
        label ?
            <Label { ...labelProps } withInput={ true } size={ restProps.size }>
                <div className="input-caption-wrapper">

                <AntInput.Password
                    iconRender={ passwordIcon }
                    { ...restProps }
                    disabled={ disabled }
                />
                {
                    caption &&
                    <NackleCaption { ...captionProps } state={ restProps.status } disabled={ disabled }/>
                }
                </div>
            </Label>
            :
            <div className="input-caption-wrapper">
                <AntInput.Password
                    iconRender={ passwordIcon }
                    { ...restProps }
                    disabled={ disabled }
                />
                {
                    caption &&
                    <NackleCaption { ...captionProps } state={ restProps.status } disabled={ disabled } />
                }
            </div>
    );
};

export default Password;
